import { Direction } from 'types'

export const SET_DIRECTION = 'wordBankSelect.setDirection'

export function setDirection(payload: Direction) {
  return {
    type: SET_DIRECTION,
    payload
  } as const
}

export type WordBankSelectAction = ReturnType<typeof setDirection>
